/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Injectable } from '@angular/core';
import { TourStateDefinition } from '@tours/models/tour-state-definition';

@Injectable({
  providedIn: 'root'
})
export class TourStatesService {

  constructor() { }

  getStateDefinitions(): TourStateDefinition[] {
    return [
      {name: 'new', svgIcon: 'planned', matIcon: null},
      {name: 'material_defined', svgIcon: 'employee', matIcon: null},
      {name: 'teams_scheduled', svgIcon: 'truck', matIcon: null},
      {name: 'delivery_note_returned', svgIcon: null, matIcon: 'description'},
      {name: 'delivery_note_captured', svgIcon: 'euro', matIcon: null},
      {name: 'tour_cleared'}
    ];
  }
}
